<!--
  Example usage (without template):<template>

    <SimpleItemList :items="myItems" separator="|"/>


  Example usage (with template):<template>

    <SimpleItemList :items="myItems">
      <template slot scope="props">
        <span class="item">{{ props.item }}</span>
      </template>
    </SimpleItemList>
-->

<script>
export default {
  props: {
    items: { type: Array },
    tag: { type: String, default: 'div' },
    separator: { type: String, default: ', ' },
  },
  render(createElement) {
    const self = this
    const elements = []
    this.items.forEach((item, idx) => {
      // if template is defined use it, otherwise just push item as text
      if (self.$scopedSlots.default) {
        elements.push(self.$scopedSlots.default({ item }))
      } else {
        elements.push(item)
      }
      // add separator for all but last item
      if (idx < self.items.length - 1) {
        elements.push(self.separator)
      }
    })

    return createElement(this.tag, elements)
  },
}
</script>
